import * as components from './components'

export default [
  {
    path: '/quickLinkManagement',
    component: components.QuickLinkList,
    name: 'quickLinkList',
    props: true
  },
  {
    path: '/quickLinkManagement/create',
    component: components.QuickLinkCreate,
    name: 'quickLinkCreate',
    props: true
  },
  {
    path: '/quickLinkManagement/:uuid/edit',
    component: components.QuickLinkCreate,
    name: 'quickLinkEdit',
    props: true
  }
]



// WEBPACK FOOTER //
// ./src/app/quickLink/routes.js